import React from 'react';
import Switch from '@mui/material/Switch';
import styles from './CustomToggleSwitch.module.scss';
import { FormControlLabel } from '@mui/material';
import styled from '@emotion/styled';
import { PRIMARY_GREEN, WHITE } from '../../../utility/constants/common-constants';

const BaseSwitch = styled(Switch)({
  maxWidth: 45,
  height: 22,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(23px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: PRIMARY_GREEN
      } ,

      '& .MuiSwitch-thumb': {
    width: 18,
    height: 18,
    borderRadius: '25px',
    backgroundColor: WHITE
  },
    }
  },
  '& .MuiSwitch-thumb': {
    width: 18,
    height: 18,
    borderRadius: '25px',
    backgroundColor: "#666666" 
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    borderRadius: '25px',
    backgroundColor: "#d1d1d1",
    boxSizing: 'border-box'
  }
});

export interface CustomToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;

}

export const CustomToggleSwitch = ({ label, checked, onChange, ...props }: CustomToggleSwitchProps) => {
  return (
    <FormControlLabel
      control={
        <BaseSwitch
          checked={checked}
          onChange={onChange}
          {...props}
        />
      }
      label={label}
      classes={{ label: styles.label }}
    />
  );
};

export default CustomToggleSwitch;

